var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMesterCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 16,
    viewBox: "0 0 27 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_709_994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.81669 16C12.1306 16 15.6299 12.4144 15.6299 7.99848C15.6299 3.58254 12.1311 0 7.81669 0C3.50227 0 0 3.58204 0 7.99797C0 12.4139 3.49929 15.9995 7.81669 15.9995V16Z",
    fill: "#E2001A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1868 16C23.5007 16 27 12.4144 27 7.99848C27 3.58254 23.5007 0 19.1868 0C14.8728 0 11.3735 3.58204 11.3735 7.99797C11.3735 12.4139 14.8689 15.9995 19.1868 15.9995V16Z",
    fill: "#F6A800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4963 13.4861C12.1807 12.0521 11.373 10.12 11.373 7.99795C11.373 5.87586 12.1663 3.98448 13.457 2.55756L13.6214 2.64547C14.8689 4.06527 15.6299 5.94192 15.6299 7.99845C15.6299 10.055 14.8614 11.9464 13.607 13.3697L13.4963 13.4866V13.4861Z",
    fill: "#EB690A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_709_994"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMesterCard);
export default __webpack_public_path__ + "static/media/MesterCard.10850ea42b7e55dd5c1a048c6f690ec1.svg";
export { ForwardRef as ReactComponent };